import { render, staticRenderFns } from "./ServerComponent.vue?vue&type=template&id=37483f48&"
import script from "./ServerComponent.vue?vue&type=script&lang=ts&"
export * from "./ServerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ServerComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports